<template>
  <div class="top-content-wrap">
    <div class="header-container">
      <div class="container">
        <div class="row">
          <div class="col-xs col-lg-12">
            <div class="header-claim">
              <div class="claim-title">
                <h1>
                  Auto online verkaufen - <br/>sicher & bequem von zu Hause
                </h1>
              </div>
              <div class="claim-content">
                <ul>
                  <li>Alles online & kostenlos</li>
                  <li>Abholung & Abmeldung inklusive</li>
                  <li>Keine Telefonate & Nachverhandeln</li>
                  <li>Höchstpreis erzielen per Auktion</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ContentWidgetForm />
    <Vorteile />
    <section class="funktioniert-online-verkauf">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-lg-12">
            <h2 class="text-align">
              Auto verkaufen - sicher und online <span>So funktioniert es:</span>
            </h2>
            <ul class="step-list">
              <li class="step">
                <div class="step-block">
                  <img
                    src="../assets/icons/step-1.svg"
                    alt="Schnellbewertung in < 1 Minute"
                  />
                  <p>Schnellbewertung in unter einer <br>Minute durchführen.</p>
                </div>
              </li>
              <li class="step">
                <div class="step-block">
                  <img
                    src="../assets/icons/step-2.svg"
                    alt="Weitere Fahrzeugdaten, Zustand und Bilder erfassen"
                  />
                  <p>
                    Weitere Fahrzeugdaten, Zustand <br>und Bilder erfassen.
                  </p>
                </div>
              </li>
              <li class="step">
                <div class="step-block">
                  <img
                    src="../assets/icons/step-3.svg"
                    alt="Bei Bedarf begutachtet ein TÜV Gutachter Ihr Fahrzeug direkt zu Hause"
                  />
                  <p>
                    Bei Bedarf begutachtet ein TÜV-Gutachter dein Fahrzeug direkt bei <br>dir zu Hause.
                  </p>
                </div>
              </li>
              <li class="step">
                <div class="step-block">
                  <img
                    src="../assets/icons/step-4.svg"
                    alt="Mit Hilfe zertifizierter Autohändler, erzielen wir ein Höchstgebot für Ihr Fahrzeug"
                  />
                  <p>
                    Zusammen mit dir vereinbaren <br>wir deinen Mindestpreis und <br>starten die Auktion.
                  </p>
                </div>
              </li>
              <li class="step">
                <div class="step-block">
                  <img
                    src="../assets/icons/step-5.svg"
                    alt="Sie entscheiden ob Sie verkaufen möchten.  Wir kümmern uns um alles Weitere!"
                  />
                  <p>
                    Der Käufer zahlt das Höchstgebot <br>und kümmert sich um die <br>Abmeldung und Abholung.
                  </p>
                </div>
              </li>
            </ul>

            <div class="action-block text-align">
              <button @click="makeRedirect">Auto verkaufen</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
          <div class="col-xs-12 col-lg-12">
            
            <hr />
          </div>
        </div>
    </section>
    <section class="online-verkaufen-fahrzeugwert">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-lg-12">
            <h2 class="text-align">
              Auto online verkaufen <br />oder Inzahlungnahme bei Online-Kauf
            </h2>
          </div>
        </div>
        <div class="row teaser-wrap-row">
          <div class="col-xs-12 col-lg-4">
            <div class="teaser-block teaser-block-01 text-align">
              <div class="icon-block">
                <img
                  src="../assets/icons/online-verkaufen.svg"
                  alt="Online Verkaufen"
                />
              </div>
              <h3 class="teaser-title h4">Online verkaufen</h3>
              <p>
                Wir erzielen für dich das Höchstgebot per Auktion. Der <br>Käufer kümmert sich um die Bezahlung, Abholung und Abmeldung – 100 % online und <br>kostenlos.
              </p>
            </div>
          </div>
          <div class="col-xs-12 col-lg-4">
            <div class="teaser-block teaser-block-02 text-align">
              <div class="icon-block">
                <img
                  src="../assets/icons/inzahlungnahme.svg"
                  alt="Inzahlungnahme"
                />
              </div>
              <h3 class="teaser-title h4">Inzahlungnahme</h3>
              <p>
                Gib dein altes Auto in Zahlung und kaufe dein neues <br>Wunschfahrzeug online – mit <span @click="openModal('garantie')">Garantie <i class="fas fa-info-circle" style="cursor:pointer" /></span> und kostenloser <span @click="openModal('lieferung')">Lieferung <i class="fas fa-info-circle" style="cursor:pointer" /></span>.
              </p>
            </div>
          </div>
          <div class="col-xs col-lg-4">
            <div class="teaser-block teaser-block-03 text-align">
              <div class="icon-block">
                <img
                  src="../assets/icons/nur-preis-ermitteln.svg"
                  alt="Nur Preis ermitteln"
                />
              </div>
              <h3 class="teaser-title h4">Nur Preis ermitteln</h3>
              <p>
                Du erhältst den Fahrzeugwert in weniger als einer Minute. <br>Nutze unsere TÜV Rheinland zertifizierte Marktwertermittlung!
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="action-block text-align">
              <button @click="makeRedirect">Dein Auto verkaufen</button>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <Garantie :isOpen="showModal['garantie']" @close="closeModal('garantie')" />
        <DaysModal :isOpen="showModal['days']" @close="closeModal('days')" />
        <LieferungModal :isOpen="showModal['lieferung']" @close="closeModal('lieferung')" />
        <WidgetModal :isOpen="showModal['widget']" @close="closeModal('widget')" />
  </div>
</template>

<script>
import ContentWidgetForm from "./ContentWidgetForm";
import Garantie from "./modals/GarantieModal.vue";
import DaysModal from "./modals/14DaysModal.vue";
import LieferungModal from "./modals/LieferungModal.vue";
import WidgetModal from './modals/WidgetModal.vue';
import Vorteile from './Vorteile.vue';
import { redirectToEvaluation } from "../services/helpers";

export default {
  name: "Header",
  data() {
    return {
      showModal: {
        garantie: false,
        days: false,
        lieferung: false,
        widget: false,
      },
    }
  },
  components: {
    ContentWidgetForm,
    Garantie,
    DaysModal,
    LieferungModal,
    WidgetModal,
    Vorteile
  },
  methods: {
    openModal(modalId) {
      this.showModal[modalId] = true;
    },
    closeModal(modalId) {
      this.showModal[modalId] = false;
    },
    makeRedirect() {        
      redirectToEvaluation(this.$store, true, 'sell_car', 'online_lp');
    }
  }
};
</script>
<style lang="scss">
@import "~@/assets/vars";

a:hover {
  text-decoration: none !important;
}

body {
  font-family: "Asap", sans-serif !important;
}

// redesign code
.top-content-wrap,
.top-content-wrap * {
  font-family: "Asap", sans-serif;

  i {
    font-family: 'font awesome 5 free';
  }
}

hr {
  border: 0 none;
  background: $border-dark;
  height: 1px;
  width: 100%;
}

.top-content-wrap {
  // .inner-wrapper {
  //   max-width: 1620px;
  //   margin: 0 auto;
  //   height: 100%;
  //   padding: 40px 18px;
  // }

  .header-container {
    background-image: url("../assets/online/bg-header-online-small.jpg");
    background-size: cover;
    background-position: center;
    position: relative;
    padding-top:35px;
    padding-bottom:35px;

    &:before {
      content: "";
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.35);
    }

    @include breakpoint(smallmedium) {
      background-position: center;
    }

    @include breakpoint(frommediumlarge) {
      background-image: url("../assets/online/bg-header-online-medium.jpg");
      padding-top:55px;
      padding-bottom:60px;

      &:before {
       display:none;
      }
    }

    @include breakpoint(fromgiant) {
      padding-top: 165px;
      padding-bottom: 229px;
      background-image: url("../assets/online/bg-header-online.jpg");
      background-position: center center;

      
    }

    @media screen and (min-width:1200px) and (max-height:930px) {
      padding-top:45px;
      padding-bottom:195px;
    }

    @media screen and (min-width:1200px) and (max-height:950px) {
      padding-bottom:180px;
    }

    @include breakpoint(extralarge) {
      background-position: center;
    }

    .header-claim {
      .claim-title {
        color:$white;
        position: relative;
        padding-left: 14px;

        &:before {
          content:"";
          display:block;
          width: 3px;
          height: 100%;
          background-color: $white;
          left:0;
          top:50%;
          transform:translateY(-50%);
          position:absolute;
        }
        
        @include breakpoint(frommediumlarge) {
          margin-bottom: 34px;
        }
        @include breakpoint(extralarge) {
          margin-bottom: 40px;
        }

        @media screen and (min-width:1200px) and (max-height:950px) {
          h1 {
            font-size:50px !important;
            line-height:60px !important;
          }
        }

        span {
          display:block;
          font-size:20px;
          line-height:28px;

          @include breakpoint(frommediumlarge) {
            font-size:32px;
            line-height:40px;
          }

          @include breakpoint(fromgiant) {
            font-size:50px;
            line-height:70px;
          }

          @include breakpoint(extralarge) {
            font-size:60px;
            line-height:69px;
          }

          @media screen and (min-width:1200px) and (max-height:950px) {
            font-size:32px;
            line-height:40px;
          }
        }
      }
      .claim-content {
        ul {
          padding-left: 0;

          li {
            font-weight: 600;
            font-size: 15px;
            line-height: 22px;
            padding-left: 23px;
            position: relative;
            margin-bottom: 8px;
            color:$white;

            @include breakpoint(frommediumlarge) {
              font-size: 20px;
              line-height: 30px;
              padding-left: 36px;
            }

            @include breakpoint(fromgiant) {

              br {
                display: none;
              }
            }

              &:before {
                    content: "\f00c";
                    font-family: 'Font Awesome 5 Free';
                    font-weight: 700;
                    display: block;
                    color: $green-light;
                    font-size: 18px;
                    position: absolute;
                    left: 0;
                    top: 0;
                    background:none;
                }
          }
        }
      }
    }
  }

  section.online-verkaufen-fahrzeugwert {
    padding-top:20px;
    padding-bottom: 30px;

    @include breakpoint(frommediumlarge) {
      padding-top: 36px;
      padding-bottom: 60px;
    }

    @include breakpoint(fromgiant) {
      padding-top: 76px;
      padding-bottom: 110px;
    }

    h2 {
      br {
        display:none;
        @include breakpoint(fromlarge) {
          display:block;
        }
      }
    }
  }

  .teaser-wrap-row {
    padding-top: 10px;

    @include breakpoint(frommediumlarge) {
      padding-top:23px;
    }

    @include breakpoint(fromgiant) {
      padding-top: 35px;
      padding-bottom: 55px;
    }

    .teaser-block {
      margin-bottom:23px;
      @include breakpoint(frommediumlarge) {
         margin-bottom:55px;

         &:last-of-type {
           margin-bottom:43px;
         }
      }
      @include breakpoint(fromgiant) {
         margin-bottom:0;

         &:last-of-type {
           margin-bottom:0;
         }
      }
      br {
        display:none;
        @include breakpoint(frommediumlarge) {
          
          &:nth-of-type(2) {
            display:none;
          }
        }
        @include  breakpoint(extralarge) {
          display:block;
        }
      }

      .icon-block {
        margin-bottom: 13px;

        @include breakpoint(frommediumlarge) {
            margin-bottom:30px;
        }

        img {
          height:76px;

          @include breakpoint(frommediumlarge) {
            height:auto;
          }
        }
      }
      .teaser-title {
        
        @include breakpoint(frommediumlarge) {
          padding-bottom: 12px;
        }
      }
    }
  }

  .funktioniert-online-verkauf {
    padding-top: 25px;

    @include breakpoint(fromgiant) {
      display:block;
      padding-top:0;
    }
    .action-block {
      padding-top:20px;
      margin-bottom:35px;
      @include breakpoint(frommediumlarge) {
        padding-top: 0;
        margin-bottom: 50px;
      }
      @include breakpoint(fromgiant) {
        padding-top: 61px;
        margin-bottom: 75px;
      }
    }
  }

  ul.step-list {
    padding: 15px 0 0;
    width: 100%;

    @include breakpoint(fromlarge) {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
    }

    @include breakpoint(fromgiant) {
      padding: 25px 0 0;
    }

    @include breakpoint(extralarge) {
      padding: 25px 50px 0;
    }

    li {
      
      width:100%;
      position:relative;

      @include breakpoint(fromlarge) {
        width:20%;
        text-align: center;
      }

      .step-block {
        display:flex;
        align-items: center;
        margin-bottom:20px;

        @include breakpoint(frommediumlarge) {
          margin-bottom:40px;
        }

        @include breakpoint(fromlarge) {
          display:block;
          padding:0 10px;
        }

        @include breakpoint(fromgiant) {
          margin-bottom:0;
        }

        @include breakpoint(full) {
          padding:0;
        }

        br {
          display:none;
          @include breakpoint(full) {
            display:block;
          }
        }

        img {
          width:75px;
          margin-right:22px;

          @include breakpoint(fromlarge) {
            margin-right:0;
          }

          @include breakpoint(fromgiant) {
            width:auto;
            
          }
        }

        p {
          margin-bottom:0;
          @include breakpoint(fromlarge) {
            font-size:16px;
          }

          @include breakpoint(full) {
            font-size: 18px;
            
          }
        }
      }

      &:last-of-type {
        &:after {
          display:none;
        }
      }
      
      @include breakpoint(fromlarge) {
        &:after {
          content:"";
          display:block;
          height: 1px;
          background: $border-dark;
          width: 63px;
          position:absolute;
          right:-35px;
          top:40px;
        }
      }

      @include breakpoint(fromgiant) {
        &:after {
          top:63px;
        }
      }
      img {       

        @include breakpoint(fromgiant) {
          margin-bottom: 26px;
        }
      }
    }
  }

  .contact-container {
    background:$light-gray;
    border-radius: 12px;
    margin-top: 35px;

    @include breakpoint(frommediumlarge) {
      margin-top: 55px;
    }

    @include breakpoint(fromgiant) {
      background:transparent;
      border-radius:0;
      margin-top:0;
    }
  }

  .contact-block {
    background: $light-gray;
    border-radius: 12px;
    padding: 26px 0 34px;
    text-align:center;

    @include breakpoint(frommediumlarge) {
      padding:50px 0 62px;
    }

    @include breakpoint(fromgiant) {
      padding: 50px 0;
      margin-top: 75px;
      padding: 50px 30px;
      text-align:left;
    }

    @include breakpoint(extralarge) {
      padding: 50px 60px;
    }

    @include breakpoint(full) {
      padding: 50px 135px;
    }

    .inner-wrap {    

      @include breakpoint(fromgiant) {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      p {
        margin-bottom: 0;
        font-size: 20px;
        line-height: 30px;

        @include breakpoint(fromgiant) {
          font-size: 24px;
          line-height: 32px;
        }

         @include breakpoint(extralarge) {
          font-size: 30px;
          line-height: 50px;
        }

        strong {
          display:block;

          @include breakpoint(frommediumlarge) {
            display:inline;
          }
        }
      }

      .action-block {
        padding-top:20px;
        text-align:center;
        flex-direction: column;
        display:flex;
        align-items: center;
        .btn:first-of-type {
          margin-bottom:25px;

          @include breakpoint(frommediumlarge) {
            margin-right: 47px;
            margin-bottom:0;
          }
        }

        @include breakpoint(frommediumlarge) {
          text-align:left;
          justify-content: center;
          flex-direction: row;
        }

        @include breakpoint(fromgiant) {
          padding-top:0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue